import React from 'react';
import {
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Box,
    Skeleton,
} from '@mui/material';

const InquiryResultSkeleton: React.FC = () => {
    const skeletonItems = [1, 2, 3, 4];

    return (
        <Box sx={{margin: 'auto', position: 'relative'}}>
            <List sx={{position: 'relative'}}>
                {skeletonItems.map((_, index) => (
                    <ListItem
                        key={index}
                        sx={{
                            padding: '4px !important',
                            alignItems: 'flex-start',
                            position: 'relative',
                            paddingY: '16px',
                            '&:before': {
                                content: '""',
                                position: 'absolute',
                                right: '15px',
                                top: '50%',
                                bottom:
                                    index === skeletonItems.length - 1
                                        ? 'auto'
                                        : '-5%',
                                width: '1px',
                                backgroundColor:
                                    index === skeletonItems.length - 1
                                        ? 'transparent'
                                        : '#ccc',
                            },
                        }}
                    >
                        <ListItemIcon sx={{minWidth: '30px'}}>
                            <Skeleton
                                variant="circular"
                                width={24}
                                height={24}
                            />
                        </ListItemIcon>
                        <ListItemText
                            sx={{marginTop: '2px'}}
                            primary={<Skeleton variant="text" width="60%" />}
                            secondary={<Skeleton variant="text" width="80%" />}
                        />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default InquiryResultSkeleton;
